export default {
  h1_edu: "Cursos educativos para médicos diagnósticos",
  Lessons: {
    Lesson: {
      title: "Lição",
      Files: "Anexos",
      DownloadAll: "Baixar tudo",
    },
    status: {
      success: "Concluído",
      unsuccess: "Não concluído",
      stop: "Indisponível",
    },
  },
};
